import { INotificationItem } from '@/components/Notifications/NotificationItemBase'
import store from '@/store/store'
import { HubConnectionBuilder } from '@microsoft/signalr'

export class NotificationHub {
	static async init() {
		const { state } = store
		if (!state) throw new Error('User not found')

		const hub = new HubConnectionBuilder()
		var connection = hub
			//@ts-ignore
			.withUrl(`${import.meta.env.VUE_APP_API_ATTA_SERVICES}/hubs/notification?uuid=${state.user.id}`, {
				skipNegotiation: true,
				transport: 1
			})
			.withAutomaticReconnect()
			.build()

		await connection.start()

		return {
			connection,
			onNotificationReceived: (callback: (notification: INotificationItem) => void) => connection.on('notification:received', callback),
			onNotificationRead: (callback: () => void) => connection.on('notification:read', callback)
		}
	}
}
